import { FeatureKey } from '~/core/shared/constants';
import { Permissions } from '~/core/shared/generated/Permissions';
import { MIDDLE_OFFICE_ROUTES } from '../routing/routes';
import { TenantSettingsNavigationItem } from './declarations';

/**
 * Settings navigation shared by every middle-office tenant. Tenants spread this
 * and append the items only they offer.
 */
export const MIDDLE_OFFICE_DEFAULT_SETTINGS_NAVIGATION: TenantSettingsNavigationItem[] =
  [
    {
      href: MIDDLE_OFFICE_ROUTES.settingsAccount.path,
      text: 'Account',
    },
    {
      href: MIDDLE_OFFICE_ROUTES.settingsSecurity.path,
      text: 'Security',
    },
    {
      href: MIDDLE_OFFICE_ROUTES.settingsUserManagement.path,
      text: 'Users',
      permission: Permissions.UsersView,
    },
    {
      href: MIDDLE_OFFICE_ROUTES.settingsOrgManagement.path,
      text: 'Organisations',
      permission: Permissions.OrganisationsView,
      feature: FeatureKey.BrokerPortalModule,
    },
    {
      href: MIDDLE_OFFICE_ROUTES.settingsBrokerManagement.path,
      text: 'Brokers',
      permission: Permissions.BrokersView,
      feature: FeatureKey.BrokerPortalModule,
    },
    {
      href: MIDDLE_OFFICE_ROUTES.settingsRoles.path,
      text: 'Roles',
      permission: Permissions.RolesView,
    },
    {
      href: MIDDLE_OFFICE_ROUTES.settingsPermissionMatrix.path,
      text: 'Permission Matrix',
      permission: Permissions.PermissionMatrixView,
    },
  ];
